import React from 'react';
import HistoryTableHeader from './historyTableHeader';
import { PermanentLicenseColumnCaptions } from './tableColumnCaptions';

const PermanentLicenseHistoryTableHeader = (props) => {
  const { editedFields, objectData } = props;

  const title = [{
    title: PermanentLicenseColumnCaptions.key,
    value: objectData ? objectData.key : '',
  }, {
    title: PermanentLicenseColumnCaptions.client.fullName,
    value: objectData
      ? objectData.client
        ? objectData.client.fullName : ''
      : ''
  }];

  return <HistoryTableHeader editedFields={editedFields} captions={PermanentLicenseColumnCaptions} objectData={objectData} title={title}/>
};

export default PermanentLicenseHistoryTableHeader;


// WEBPACK FOOTER //
// ./src/components/permanentLicenseHistoryTableHeader.js